import { useSelectedAccountStore } from '../stores/useSelectedAccountStore'
import { usePaginateAccounts } from './usePaginateAccounts'

export function useManageApplicationsAccount() {
  const { account } = useSelectedAccountStore()
  const { accounts } = usePaginateAccounts()

  const ACCOUNT_SELECTED = accounts.find((acc) => acc.id === account?.id)

  return {
    ACCOUNT_SELECTED,
  }
}
